import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { afficherFichier } from '../../App_Code/API';
import { mapStateToPropsWrapper, verificationProps } from '../CaptureErreurs';
import Card from '../Card';
import LigneAdresse from '../Adresse';

const CardCopro = ({
    Nom, Img, Description, Adresse, ListeFou_VisiblePar, EstMembreCS
}) => (
    <Card Titre={CardCopro.titleName} SousTitre={Nom}>
        <div className="card-text mb-3">
            <p>
                {Img && (
                    <img
                        src={afficherFichier(Img)}
                        alt=""
                        className="rounded mx-auto d-block border border-secondary img-fluid img-logo"
                    />
                )}
            </p>
            {Description && (
                <blockquote className="blockquote">
                    <div className="mb-0" dangerouslySetInnerHTML={{ __html: Description }} />
                </blockquote>
            )}
            <LigneAdresse {...Adresse} />
        </div>
        { ListeFou_VisiblePar == 1 || (ListeFou_VisiblePar == 2 && EstMembreCS) ? 
            <React.Fragment>
                <Link to="/MaCopropriete/Fournisseurs" className="btn btn-outline-primary  mt-3 mr-3">
                    { ListeFou_VisiblePar == 2 ? <span className="badge badge-pill badge-cs mr-1" title="Vous avez accès à cette section car vous êtes membre du conseil syndical">
                        CS
                    </span> : null}
                    Voir les fournisseurs
                </Link>
                </React.Fragment> : 
        null }
        { EstMembreCS ? 
            <React.Fragment>
                &nbsp;
                <Link to="/MaCopropriete/ProprietairesCS" className="btn btn-outline-primary mt-3 mr-3">
                    <span className="badge badge-pill badge-cs mr-1" title="Vous avez accès à cette section car vous êtes membre du conseil syndical">
                        CS
                    </span>
                    Voir les propriétaires
                </Link>
            </React.Fragment> : 
        null }
    </Card>
);
CardCopro.displayName = 'CardCopro';
CardCopro.titleName = 'Ma copropriété';
CardCopro.requiredProps = [
    'Nom', // Nom de la copropriété
    'Img', // Photo de la copropriété
    'Description', // Description de la copropriété
    'Adresse', // Adresse de la copropriété
    'ListeFou_VisiblePar', // Droit accès liste fou
    'EstMembreCS', // Bool si pro est membre CS
];

function mapStateToProps({
    CopStore: {
        Cop: {
            Ind: { Nom, Adresse },
            Img,
            Description,
        },
    },
    SynStore: {
        Syn : { ListeFou_VisiblePar },
    },
    AdhStore: { EstMembreCS },
}) {
    return {
        Nom,
        Img,
        Description,
        Adresse,
        EstMembreCS,
        ListeFou_VisiblePar,
    };
}

export default connect(mapStateToPropsWrapper(mapStateToProps))(verificationProps(CardCopro));



// WEBPACK FOOTER //
// ./src/components/MaCopro/CardCopro.js